import proj4 from "proj4"; // register,

if (typeof window !== "undefined") {
  window.proj4 = window.proj4 || proj4;
}
proj4.defs(
  "EPSG:2157",
  "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
);
// register(proj4);
export default proj4;
